import { ScrollComponent } from '../../common/scrollComponent'
import StatusNotifications from '../common/statusNotifications'
import withFallback from '../common/withFallback'
import { SCREEN_TYPE } from '../constants'
import WrapPagination from './WrapPagination'

const NotificationList = ({ todayData, olderData }) => {
  return (
    <>
      <ScrollComponent>
        {todayData.length > 0 && (
          <StatusNotifications
            title="systemNotifications.TODAY"
            ids={todayData}
            addBottomSpacing
            screenType={SCREEN_TYPE.VIEW_ALL}
            timeType={'todayData'}
          />
        )}
        {olderData.length > 0 && (
          <StatusNotifications
            title="systemNotifications.OLDER"
            ids={olderData}
            screenType={SCREEN_TYPE.VIEW_ALL}
            timeType={'olderData'}
          />
        )}
      </ScrollComponent>
      <WrapPagination />
    </>
  )
}

export default withFallback(NotificationList)
